import Map from 'components/map';

const renderInfoWindow = (item, resources) => {
    let built = ``;
    // Only for pickup point (not for store) we should display the point name in the info window
    if ('name' in item && item.name !== '' && item.name !== null && item.name !== undefined && resources.choosePoint) {
        built += `<span class="store-name strong">${item.name}</span><br>`;
    } else {
        built += `<div class="store-name hide">${item.name}</div>`;
    }
    let storeHours = $('.store-hours-' + item.ID).length > 0 ? '<br>' + $('.store-hours-' + item.ID)[0].outerHTML : '';
    built += `<p>${item.address1}, <br>${item.city} ${item.postalCode} ${storeHours}</p>`;

    if ('phone' in item && item.phone !== null && item.phone !== undefined) {
        built += `<span class="store-phone-detail-box">
            <i class="cc-storeDetails-container_contactsNumber_phone" aria-hidden="true"><img src="${$('.findinstore-data-container').data('phone-icon')}" /></i>
            <a class="js-storelocator-phone" href="tel:${item.phone}">${item.phone}</a>
            </span>`;
    }

    built += `<span class="store-gotomps-box float-right">
        <a target='_blank' href="https://maps.google.com/maps/place/${item.latitude},${item.longitude}"><img src="${$('.findinstore-data-container').data('directions-icon')}" /></a>
        </span>`;

    if (resources.chooseStore) {
        built += `<div><div class="spacer small"></div><button type="button" class="button no-margin js-choose-store-infowindow font-size-12" data-store-id="${item.ID}">${resources.chooseStore}</button></div>`;
    } else if (resources.choosePoint) {
        built += `<div><div class="spacer small"></div><button type="button" class="button no-margin js-choose-point-infowindow font-size-12" data-store-id="${item.ID}">${resources.choosePoint}</button></div>`;
    }

    return built;
};

/* eslint-disable no-undef */
export default class IntimissimMap extends Map {
    updateMarkers (stores, resources, isCartOrCheckout = false) {
        // Delete markers
        for (let i = 0; i < this.markers.length; i++) {
            this.markers[i].setMap(null);
        }

        // Reset markers and bounds
        this.markers = [];
        this.bounds = new google.maps.LatLngBounds();

        const icon = {
            url: this.$target.data('marker-url'),
            labelOrigin: new google.maps.Point(8, 9)
        };

        var labelIndex = 0;
        var labels = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

        stores.forEach((store) => {
            const item = store.store;
            const storeLocation = new google.maps.LatLng(item.latitude, item.longitude);
            // let labelAttr = ' ';
            let label = ' ';
            let increment = Math.floor(labelIndex >= labels.length ? labelIndex / labels.length : 0);
            let index = Math.floor(labelIndex > labels.length ? (labelIndex - Math.floor(labelIndex / labels.length).toFixed(0) * labels.length) : labelIndex);
            label = labels[index % labels.length] + (increment > 0 ? increment + '' : '');
            // if (isCartOrCheckout) {
            //     labelAttr = { text: label, color: 'white', fontSize: '  10px' };
            // }

            labelIndex++;

            const marker = new google.maps.Marker({
                position: storeLocation,
                map: this.map,
                title: item.name,
                // label: labelAttr,
                icon: icon,
                label: {
                    text: label,
                    align: 'center',
                    color: 'white',
                    fontSize: '10px',
                    lineHeight: '14px',
                    fontWeight: '400',
                    fontFamily: "'Gill Sans Nova', Arial, sans-serif"
                }
            });

            this.markers.push(marker);

            marker.addListener('click', () => {
                this.infowindow.setOptions({
                    content: renderInfoWindow(item, resources)
                });
                this.infowindow.open(this.map, marker);
                $('body').trigger('analytics:clickonBlackMarker', item);
            });

            // Create a minimum bound based on a set of storeLocations
            this.bounds.extend(marker.position);
        });

        this.fitBounds(stores);
    }
}
